import { MapTo } from '@adobe/aem-react-editable-components';
import CardFinderResults, { CardFinderResultsEditConfig } from './CardFinderResults';

export default MapTo('cob-corp-acquisition/components/creditonebank/card-finder-results')(CardFinderResults, CardFinderResultsEditConfig);